import iphone from "../../assets/iphone.png";
import screen from "../../assets/screens/2.png";
import Vector from "../../assets/Vector.png";
import googlePlay from "../../assets/google-play.svg";
import appStore from "../../assets/app-store.svg";
import "./style.css";

const Header = () => {
	return (
		<header id="Home">
			<div className="header">
				<img src={Vector} alt="Vector" className="Vector" />
				<div className="container">
					<div className="row">
						<div className="col-md-6 col-12 d-flex justify-content-end">
							<div className="squire">
								<div className="title-head">
									<p className="title">A Great App Makes Your Life Better</p>
									<p className="description">
										Amet minim mollit non deserunt ullamco est sit aliqua dolor
										do amet sint. Velit officia consequat duis enim velit
										mollit. Exercitation veniam consequat sunt nostrud amet.
									</p>
									<p className="download-now">Download App Now</p>
									<div className="download-apps">
										<img src={googlePlay} className="mt-1" alt="googlePlay" />
										<img src={appStore} alt="appStore" />
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-12 d-flex justify-content-end justify-center-mobile">
							<div className="phone-head">
								<div className="phone">
									<img src={iphone} className="iphone" alt="iphone" />
									<img src={screen} className="screen" alt="screen" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};
export default Header;
